<template>
    <div>
        <vue-snotify></vue-snotify>
        <b-row>
            <b-col sm="12">
                <h5 class="h5-color"><span class="header-icon"><i class="nav-icon icon-direction"></i></span>Customer Summary</h5>
            </b-col>
        </b-row>

        <b-row class="row-bottom">
            <b-col sm="12" md="12" lg="12">
                <table class="table table-bordered table-striped table-width table-sm">
                    <tr>
                       
                        <td class="condition td-topic">&nbsp;Type of Cover</td>
                        <td class="reason td-reason"><strong>{{ProposerData.customer_type == 1 ? 'INDIVIDUAL' : 'CORPORATE'}}</strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic">&nbsp;Title</td>
                        <td class="reason td-reason"><strong>{{ProposerData.title}}</strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic">&nbsp;First Name</td>
                        <td class="reason td-reason"><strong>{{ProposerData.first_name}}</strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic">&nbsp;Last Name</td>
                        <td class="reason td-reason"><strong>{{ProposerData.last_name}}</strong></td>
                    </tr>
                    <tr v-if="ProposerData.customer_type == 2">
                       
                        <td class="condition td-topic">&nbsp;Company Name</td>
                        <td class="reason td-reason"><strong>{{ProposerData.company_name}}</strong></td>
                    </tr>
                    <tr v-if="ProposerData.customer_type == 2">
                       
                        <td class="condition td-topic">&nbsp;Business Register No</td>
                        <td class="reason td-reason"><strong>{{ProposerData.business_reg_no}}</strong></td>
                    </tr>
                    <tr v-if="ProposerData.customer_type == 2">
                       
                        <td class="condition td-topic"> Company Register Date</td>
                        <td class="reason td-reason"><strong> {{ProposerData.company_reg_date}} </strong></td>
                    </tr>
                     <tr>                       
                        <td class="condition td-topic"> Customer Preferred Language</td>
                        <td class="reason td-reason"><strong> {{ProposerData.prefered_language}} </strong></td>
                    </tr>
                     <tr>                       
                        <td class="condition td-topic"> Preferred Mode of Communication</td>
                        <td class="reason td-reason"><strong> {{ProposerData.prefered_communication.join(', ') }} </strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic"> Address Line1</td>
                        <td class="reason td-reason"><strong> {{ProposerData.adr_line1}} </strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic"> Address Line2</td>
                        <td class="reason td-reason"><strong> {{ProposerData.adr_line2}} </strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic"> Address Line3</td>
                        <td class="reason td-reason"><strong> {{ProposerData.adr_line3}} </strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic"> City</td>
                        <td class="reason td-reason"><strong> {{filterObjects(city_list  ,ProposerData.city)}} </strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic"> Contact No Mobile</td>
                        <td class="reason td-reason"><strong> {{ProposerData.contact_no_mobile}} </strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic"> Contact No Land</td>
                        <td class="reason td-reason"><strong> {{ProposerData.contact_no_land}} </strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic"> Email Addreess</td>
                        <td class="reason td-reason"><strong> {{ProposerData.email_address}} </strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic"> NIC Number</td>
                        <td class="reason td-reason"><strong> {{ProposerData.nic}} </strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic"> VAT NO</td>
                        <td class="reason td-reason"><strong> {{ProposerData.vat_no}} </strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic"> Business Occupation</td>
                        <td class="reason td-reason"><strong> {{ProposerData.business_occupation}} </strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic"> Garaged Address</td>
                        <td class="reason td-reason"><strong> {{ProposerData.garaged_address}} </strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic"> Name of the Owner </td>
                        <td class="reason td-reason"><strong> {{OwnershipData.owner_name}} </strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic"> Name of the Registered Owner </td>
                        <td class="reason td-reason"><strong> {{OwnershipData.registered_owner_name}} </strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic"> Name of the institution who has financial interest </td>
                        <td class="reason td-reason"><strong> {{filterObjects(insurance_cmp_list  ,OwnershipData.financial_inst_name)}} </strong></td>
                    </tr>
                    <tr>
                        <td class="condition td-topic"> Vehicle will be driven by </td>
                        <td class="reason td-reason"><strong>{{filterObjects(vehicle_driven_by_list,DriverData.vehicle_driven_by)}} </strong></td>
                    </tr>

                </table>
            </b-col>
        </b-row>



        <b-row>
            <b-col sm="12">

                <h5 class="h5-color"><span class="header-icon"><i class="nav-icon icon-direction"></i></span>Vehicle Summary</h5>
            </b-col>
        </b-row>

        <b-row class="row-bottom">
            <b-col sm="12" md="12" lg="12">
                <table class="table table-bordered table-striped table-width table-sm">
                    <tr>
                       
                        <td class="condition td-topic">&nbsp;Vehicle Type</td>
                        <td class="reason td-reason"><strong>{{filterObjects(vehicle_type_list  ,VehicleData.vehicle_type)}}</strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic">&nbsp;Vehicle Usage</td>
                        <td class="reason td-reason"><strong>{{filterObjects(vehicle_usage_list  ,VehicleData.vehicle_usage)}}</strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic">Fuel Type</td>
                        <td class="reason td-reason"><strong>{{filterObjects(fuel_type_list  ,VehicleData.fuel_type)}}</strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic">Is Registered</td>
                        <td class="reason td-reason"><strong>{{VehicleData.is_registered == 1 ? 'YES' : 'NO' }}</strong></td>
                    </tr>
<!--                    <tr>-->
<!--                       -->
<!--                        <td class="condition td-topic">Vehicle No Format</td>-->
<!--                        <td class="reason td-reason"><strong>{{filterObjects(vehicle_no_format_list  ,VehicleData.vehicle_no_format)}}</strong></td>-->
<!--                    </tr>-->
                    <tr>
                       
                        <td class="condition td-topic">Vehicle Number</td>
                        <td class="reason td-reason"><strong>{{VehicleData.vehicle_number}}</strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic">Year Of Make</td>
                        <td class="reason td-reason"><strong>{{filterObjects(year_of_make_list  ,VehicleData.year_of_make)}}</strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic">Make</td>
                        <td class="reason td-reason"><strong>{{filterObjects(vehicle_make_list  ,VehicleData.vehicle_make)}}</strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic">Model</td>
                        <td class="reason td-reason"><strong>{{filterObjects(vehicle_model_list  ,VehicleData.vehicle_model)}}</strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic">Chassis No</td>
                        <td class="reason td-reason"><strong>{{VehicleData.chassis_no}}</strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic">Engine No</td>
                        <td class="reason td-reason"><strong>{{VehicleData.engine_no}}</strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic">Cubic Capacity</td>
                        <td class="reason td-reason"><strong>{{VehicleData.cubic_capacity}}</strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic">Seating Capacity (including driver)</td>
                        <td class="reason td-reason"><strong>{{VehicleData.seating_capacity}}</strong></td>
                    </tr>

                    <tr>
                       
                        <td class="condition td-topic">Extra fittings installed</td>
                        <td>
                            <table class="table table-responsive-md">
                                <thead class="table-success-th">
                                    <th>Description</th>
                                    <th>Value</th>
                                </thead>
                                <tr v-for="item in VehicleData.vehicleAccessories" >
                                    <td>{{ item.description }}</td>
                                    <td>{{ item.value }}</td>
                                </tr>
                                <tr v-if="!VehicleData.vehicleAccessories">
                                    <td colspan="2"><strong class="reason">No Extra fittings installed</strong></td>
                                </tr>
                            </table>
                        </td>
                    </tr>

                    <tr>
                       
                        <td class="condition td-topic">Present market value</td>
                        <td class="reason td-reason"><strong>{{VehicleData.market_value}}</strong></td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic">If Vehicle imported “DUTY FREE” or Concessionary Duty </td>
                        <td class="reason td-reason">
                            <strong>{{VehicleData.is_vehicle_imported_duty_free == 1 ? 'YES' : 'NO'}}</strong>
                            <strong>{{VehicleData.imported_value ? ' - ' + VehicleData.imported_value : ''}} </strong>
                        </td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic">Is the Vehicle modified in any manner? </td>
                        <td class="reason td-reason">
                            <strong>{{VehicleData.is_the_vehicle_modified == 1 ? 'YES' : 'NO' }}</strong>
                            <strong> {{VehicleData.vehicle_modified_details  ?  ' - ' +  VehicleData.vehicle_modified_details : '' }}      </strong>
                        </td>
                    </tr>
                    <tr>
                       
                        <td class="condition td-topic">Is the vehicle presently in good condition? </td>
                        <td class="reason td-reason">
                            <strong>{{VehicleData.is_vehicle_in_good_condition ? 'YES' : 'NO'}}</strong>
                            <strong>{{VehicleData.vehicle_condition ?  ' - ' + VehicleData.vehicle_condition : ''}} </strong>
                        </td>
                    </tr>
                </table>
            </b-col>
        </b-row>

        <b-row>
            <b-col sm="12">
                <h5 class="h5-color"><span class="header-icon"><i class="nav-icon icon-direction"></i></span>Cover Details Summary</h5>
            </b-col>
        </b-row>

        <b-row class="row-bottom">
            <b-col sm="12" md="12" lg="12">
                <table class="table-width table table-bordered">

                    <div class="row">
                        <div class="col-sm-6 col-xs-12">
                            <table class="table table-bordered table-covered">
                                <thead>
                                    <th>
                                        <span>Covered<i class="fa fa-check covered"></i></span>
                                    </th>
                                </thead>

                                <tr v-for="(cover, index) in filteredCovers(1)">

                                  <td v-if="cover.cover_code == 'NATURE_OF_GOODS'" class="condition">{{cover.cover_name.toUpperCase()}} {{cover.value_required ? '- '  + cover.value_required : '' }} {{cover.goods_value ? '- ' + 'Rs ' + cover.goods_value : '' }}</td>

                                  <td v-else-if="cover.cover_code == 'M32'" class="condition">{{cover.cover_name.toUpperCase()}} {{cover.full_name ? '- ' + cover.full_name : '' }} {{cover.dob ? '- ' + cover.dob : '' }}</td>

                                  <td v-else class="condition">{{cover.cover_name.toUpperCase()}} {{cover.value_required ? '- ' + " Up To " + 'Rs ' + (Number(cover.value_required).toLocaleString()) : '' }} </td>
                                </tr>

                                <tr v-if="filteredCovers(1).length ==  0">
                                    <td colspan="2">
                                        <strong class="reason"> No data </strong>
                                    </td>
                                </tr>

                            </table>
                        </div>
                        <div class="col-sm-6 col-xs-12">
                            <table class="table table-bordered table-covered">
                                <thead>
                                    <th>
                                        <span>Not Covered<i class="fa fa-times not-covered"></i></span>
                                    </th>
                                </thead>

                                <tr v-for="(cover, index) in filteredNotCovers(0)">
                                    <td class="condition">{{cover.cover_name.toUpperCase()}}</td>
                                </tr>

                                <tr v-if="filteredCovers(0).length == 0">
                                    <td colspan="2">
                                        <strong class="reason">No data</strong>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>

                </table>
            </b-col>
        </b-row>


    </div>
</template>

<script>
    import {mapState, mapActions} from "vuex";

    export default {
        data: () => {
            return {
            };
        },
        computed: {
            ...mapState("proposal", [
                "ProposerData",
                "VehicleData",
                "CustomerData",
                "OwnershipData",
                "DriverData",
                "CoverList",
                "vehicle_type_list",
                "vehicle_no_format_list",
                "vehicle_usage_list",
                "fuel_type_list",
                "vehicle_model_list",
                "vehicle_make_list",
                "year_of_make_list",
                "insurance_cmp_list",
                "title_list",
                "city_list",
                "vehicle_driven_by_list"
            ])
        },
        mounted() {

        },
        methods: {
            filteredCovers(type) {
                return this.CoverList.filter(cover => {
                    return cover.checked == type;
                });
            },
            filteredNotCovers(type) {
              return this.CoverList.filter(cover => {
                return cover.checked != 1;
              });
            },
            filterObjects(state , index) {
                let valObj = state.filter(function(elem){
                    if(elem.code == index) return elem.name;
                });
                if(valObj[0]){
                    return valObj[0].name;
                }else{
                    return 'N/A';
                }

            }

        }
    }
</script>

<style scoped>

    .table-summary th, .table-summary td{
        padding: 2px;
    }
    .label-name {
        font-weight: bold;
        color: #31607b;
    }

    .table-covered td{
        padding: 5px;
    }

    .table-covered th{
        padding: 2px !important;
    }

    .border-none{
        border: none;
    }

    .border-none td{
        border: none;
        padding: 2px;
    }

    .table-bordered {
        border: 0px solid #c8ced3 !important;
    }

    /*th {*/
    /*    color: #49618e;*/
    /*    padding: 2px 8px;*/
    /*}*/

    .table-style {
        margin-top: 10px;
        margin-bottom: 5px;
    }

    .age-table-style {
        margin-top: 5px;
        margin-bottom: 25px;
    }

    .age-tabe {
        margin-left: 20px;
        width: 100%;
    }

    .row-bottom {
        margin-bottom: 50px;
    }

    .td-icon {
        vertical-align: top;
    }

    .td-topic {
        width: 40%;
        vertical-align: top;
    }

    .td-reason {
        width: 60%;
    }

    .incorrect {
        color: red
    }

    .td-ages {
        width: 60%;
        padding: 2px 8px;
    }

    .td-travel {
        width: 20%;
        text-align: center;
    }

    .td-travel-c {
        width: 20%;
        text-align: center;
    }

    .cover-card-1 {
        padding: 16px;
    }

    .cover-card-2 {
        padding: 16px;
    }

    .vl {
        border-left: 1px solid green;
        height: auto;
    }

    .fa {
        background-color: #59a801;
        color: #FFF;
        padding: 4px;
        margin-left: 6px;
        border-radius: 30px;
        font-size: 8px;
    }

    .covered {
        background-color: #59a801;
        color: #FFF;
        padding: 4px;
        margin-left: 6px;
        border-radius: 30px;
        font-size: 13px;
    }

    .not-covered {
        background-color: red;
        color: white;
        padding-right: 6px;
        padding-left: 6px;
        border-radius: 30px;
        font-size: 13px;
    }

    .warning{
        background-color: red;
        color: #FFF;
        padding: 4px;
        border-radius: 30px;
        font-size: 8px;
    }

    .span {
        margin-left: 6px;
        color: #525252;
    }

    .h3 {
        margin-left: 26px;
        color: #2453b3;
    }

    .center-text {
        text-align: center
    }

    p {
        color: #717887;
        margin-top: -15px;
        margin-left: 2px;
    }

    hr {
        margin-top: 1px !important;
        margin-bottom: 20px !important;
    }

    .table-width {
        width: 100%;
    }

    .condition {
        color: #31607b;
        font-weight: bold;
    }

    .reason{
        color: #31607b;
    }

    .group-summary {
        margin-top: 50px;
        margin-bottom: 80px;
    }

</style>

<style scoped>
    /*.table-success-th{*/
    /*    background-color: #f0f3f5 !important;*/
    /*}*/
</style>